<template>
  <div id="cc-inbox-panel" ref="cc-panel-inbox" class="py-4 px-3">
    <h3 class="d-inline-flex align-items-center">
      <i class="icon cc-inbox mr-2"></i>
      Inbox
      <span class="count py-1 px-2 ml-2" v-if="inboxCount > 0">{{ inboxCount }}</span>
    </h3>
    <b-form-group class="mt-3">
      <b-form-input
        id="search-inbox"
        placeholder="Search"
        class="pl-5 py-3 border-0"
        v-model="search"
        @keyup.native="searchInbox">
      </b-form-input>
    </b-form-group>
    <div class="text-center mt-3">
      <b-button
        id="cc-add-order-button"
        variant="primary"
        pill
        class="mx-auto px-3 py-2"
        @click="showAddOrderModal">
        + Add Order
      </b-button>
    </div>
    <div
      ref="cc-inbox-order"
      class="inbox-order-container px-2"
      v-infinite-scroll="loadMoreInbox"
      :infinite-scroll-disabled="loading.inbox"
      :infinite-scroll-immediate-check="true"
      infinite-scroll-distance="50">
      <div class="text-center text-muted p-2" v-if="inbox.length === 0 && !loading.inbox">
        No orders yet.
      </div>
      <template v-else>
        <InboxOrderTemplate
          v-for="(order, index) in inbox"
          :key="`inbox-order-${index}`"
          :order="order"
          :orderId="index"
          class="mb-3">
          <template slot="customerName">{{ order.name }}</template>
          <template slot="messagePreview"></template>
          <template slot="dateCreated"> {{ order.created_at | dateFromNow }} </template>
        </InboxOrderTemplate>
      </template>
      <div class="text-center text-muted p-2" v-if="loading.inbox">
        Loading...
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import _ from "lodash";
import moment from "moment";
const infiniteScroll = require('vue-infinite-scroll');

import InboxOrderTemplate from "./InboxOrderTemplate";

export default {
  components: { InboxOrderTemplate },
  data() {
    return {
      search: null
    }
  },
  computed: {
    ...mapGetters({
      brands: "conversationalCommerce/brands",
      selectedBrand: "conversationalCommerce/selectedBrand",
      loading: "conversationalCommerce/loading",
      inbox: "conversationalCommerce/inbox",
      inbox_pagination: "conversationalCommerce/inbox_pagination"
    }),
    inboxCount: {
      get() {
        return this.selectedBrand
          ? this.brands.find(brand => brand.uuid === this.selectedBrand).count
          : 0;
      },
      set(count) {
        return count;
      }
    }
  },
  filters: {
    dateFromNow(date) {
      const diffInHours = moment().diff(new Date(date), 'minutes') / 60;
      const displayTime = diffInHours >= 24
        ? `${diffInHours / 24}d`
        : diffInHours >= 1
          ? `${diffInHours}h`
          : diffInHours > 0
            ? `${diffInHours * 100}m`
            : '';

      return displayTime.replace(/ /g, '');
    }
  },
  directives: { infiniteScroll },
  created() {
    let totalHeight = 0;
    setTimeout(() => {
      totalHeight = totalHeight += this.$parent.$refs.leftPanelHeader.$el.clientHeight;
      const inboxOrderPanel = this.$refs['cc-panel-inbox'].clientHeight - this.$refs['cc-inbox-order'].clientHeight;
      totalHeight += inboxOrderPanel;
      this.$refs['cc-inbox-order'].style.maxHeight = `calc(100vh - ${totalHeight}px)`;
    }, 300);
    this.searchInbox = _.debounce(() => {
      const payload = {
        search: this.search,
        page: 1
      };
      this.$store.dispatch("conversationalCommerce/getBrandInbox", payload);
    }, 300);
  },
  methods: {
    showAddOrderModal() {
      this.$root.$emit("bv::show::modal", "cc-add-order-modal");
    },
    loadMoreInbox() {
      const payload = {};
      if (this.search) payload['search'] = this.search;
      if (
        this.inbox_pagination.page < this.inbox_pagination.max_page
        && !this.loading.inbox
      ) {
        payload['page'] = this.inbox_pagination.page += 1;      
        this.$store.dispatch("conversationalCommerce/getBrandInbox", payload);
      }
    }
  },
  watch: {
    selectedBrand() {
      this.$store.dispatch("conversationalCommerce/getBrandInbox", { page: 1 });
      this.$store.commit("conversationalCommerce/resetThreadPanel");
    }
  }
}
</script>

<style lang="scss" scoped>
#cc-inbox-panel {
  h3 {
    font-family: MainFontBold, sans-serif;
    font-weight: normal;
    font-size: 18px;
    color: #2F3941;
    .icon {
      width: 24px;
      height: 24px;
      background: url('~@/assets/images/icons/cc-inbox.svg') no-repeat center;
    }
    .count {
      background: #FF2D2D;
      font-size: 14px;
      color: #fff;
      border-radius: 15px;
    }
  }
  #search-inbox {
    border-radius: 38px;
    background: #F6F9FC url('~@/assets/images/search.svg') no-repeat center left 10px;
    font-size: 16px;
    &::placeholder {
      color: #87929D;
    }
  }
  .inbox-order-container {
    overflow-y: auto;
    padding-top: 1rem;
  }
}
</style>
